import { createTheme, ThemeOptions } from '@mui/material';
import palette from './palette';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    regular: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    regular?: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    regular: true;
  }
}

const theme: ThemeOptions = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 480,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
  typography: {
    fontFamily: '"Outfit", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.125rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.4,
    },
    regular: {
      fontSize: '18px',
      fontWeight: 300,
      lineHeight: '23px',
      fontFamily: 'Outfit, sans-serif',
    },
  },
  palette,
};

export default createTheme(theme);
